import { Link, NavLink } from "react-router-dom";
import { FaRegEnvelope, FaVoicemail } from "react-icons/fa"; 
import { MdChatBubbleOutline, MdOutlineDashboardCustomize, MdOutlineRepeat } from "react-icons/md"; 
import { FiPhoneCall, FiPhone, FiFile } from "react-icons/fi"; 
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { chatSliceAction } from "../../../store/chatSlice"

const Sidebar = () => {
    const contactAttributes = useSelector((state:any)=>{return state.emailSlice.contactAttributes})
    const timerRef = useRef<any>(null);
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const chatSliceData = useSelector((state:any)=>{return state.chatSlice});
    const consoleStorage = useSelector((state:any)=>{return state.contactSlice.consoleStorage});
    const today = new Date().getDate();
    const existingDate:any = localStorage.getItem("currentDate");
    const [agentCurrentState, setAgentCurrentState] = useState<any>("");
    const contactObj = useSelector((state:any)=>{return state.contactSlice.ChatContactObject});
    const isChatMissed = useSelector((state:any)=>{return state.chatSlice.isItMissed});
    const isChatRejected = useSelector((state:any)=>{return state.chatSlice.isItRejected});
    let missedContacts = JSON.parse(localStorage.getItem('missedContactsAgent') || '-1');
    let missedChatsAgent = JSON.parse(localStorage.getItem('missedChatsAgent') || '-1');
    
    useEffect(() => {
        timerRef.current = setInterval(() => {
            if(parseInt(existingDate) === today) {
                updateStatsTimer()
            } else {
                localStorage.setItem("currentDate", today.toString())
                localStorage.setItem("agentStateTimer", "")
                updateStatsTimer()
            }
        }, 1000);
        return () => clearTimeout(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [today, existingDate]);

    useEffect(() => {
        let missedCalls = JSON.parse(localStorage.getItem('missedContactsAgent') || '0');
        let missedChats = JSON.parse(localStorage.getItem('missedChatsAgent') || '0');
        if (agentObj) {
            setAgentCurrentState(agentObj.getState().name)
            agentObj?.onRefresh(() => {
                setAgentCurrentState(agentObj.getState().name)
            })
        }
        
        if (agentCurrentState === 'MissedCallAgent' || agentCurrentState === 'AgentHungUp') {
            let existingData = JSON.parse(missedCalls);
            existingData = existingData + 1;
            localStorage.setItem("missedContactsAgent",  JSON.stringify(existingData));
        }

        if (isChatMissed && !isChatRejected && !(contactObj?.getAttributes()?.ChannelTwo?.value ==="Email")) {
            let existingData = JSON.parse(missedChats);
            existingData = existingData + 1;
            localStorage.setItem("missedChatsAgent",  JSON.stringify(existingData));
        }

    }, [agentObj, contactObj, isChatRejected, isChatMissed, missedContacts, missedChatsAgent, agentCurrentState]);

    const onDonwloadAgentLogs = () => {
        connect.getLog().download()
    }
    const onDownloadloadCCPLogs = () => {
        const dl_link = document.createElement("a");
        dl_link.href = `data:text/plain;charset=utf-8,${encodeURIComponent(consoleStorage)}`;
        dl_link.setAttribute("download", `ccplogs-${new Date().toISOString()}.txt`);
        dl_link.style.display = "none";
        document.body.appendChild(dl_link);
        dl_link.click();
        document.body.removeChild(dl_link);
    }
    
    const updateStatsTimer = () => {
        let existingValues = localStorage.getItem("agentStateTimer");
        let agentCurrentStatus = agentObj?.getStatus().name
        if (agentCurrentStatus != "Offline"){
            if(existingValues) {
                let existingData = JSON.parse(existingValues);
                if(existingData[agentCurrentStatus]) { 
                    existingData[agentCurrentStatus] = Math.floor(Date.now()/1000) - existingData[`StartTime${agentCurrentStatus}`]
                    //existingData[agentCurrentStatus] = existingData[agentCurrentStatus] + 1
                } else {
                    existingData[agentCurrentStatus] = 1
                }
                localStorage.setItem("agentStateTimer", JSON.stringify(existingData))
            } else {
                let newTimer:any = {};

                newTimer[agentCurrentStatus] = 1;
                newTimer[`StartTime${agentCurrentStatus}`] = Math.floor(Date.now()/1000)
                localStorage.setItem("agentStateTimer", JSON.stringify(newTimer))
            }
        }

    }

    /*
    Cache might get a little too heavy, so we're probably better off.

    const logoutTimer = () => {
        checkSessionTime();
        window.setInterval(checkSessionTime, 2000);
        console.log("[Logout Timer] Started timer.");

        function checkSessionTime() {
            const now = (new Date()).getTime();
            if (!localStorage.lastPing) {
                localStorage.lastPing = now;
            }

            if (localStorage.lastPing < now - 5000) {
                localStorage.lastPing = undefined;
                console.log("[Logout Timer] Couldn't detect an active session. Last ping has been reset.");
            } else {
                localStorage.lastPing = now;
            }
        }
    } */

    return (
        <React.Fragment>
            <div className="side-bar">
                <ul className='sidebar-list list-unstyled'>
                    <li className="dropdown-hover"><NavLink className={({ isActive }) => (isActive ? 'active' : 'inactive')} to="/dashboard"><MdOutlineDashboardCustomize /> <span className="menu-name">Dashboard</span></NavLink></li>
                    <li className="dropdown-hover"><NavLink className={({ isActive }) => (isActive ? 'active' : 'inactive')} to="/calls"><FiPhone /> <span className="menu-name">Calls</span></NavLink></li>
                    <li className="dropdown-hover"><NavLink className={({ isActive }) => (isActive ? 'active' : 'inactive')} to="/chats"><MdChatBubbleOutline /> <span className="menu-name">Chats</span> {chatSliceData.numberOfChats > 0 ? (<span className="dot-alert">{chatSliceData.numberOfChats}</span>):(<></>)}</NavLink></li>
                    <li className="dropdown-hover"><NavLink className={({ isActive }) => (isActive ? 'active' : 'inactive')} to="/email"><FaRegEnvelope /> <span className="menu-name">Emails</span>{ contactAttributes?.length > 0 && <span className="dot-alert">{ contactAttributes?.length }</span>}</NavLink></li>
                    <li className="dropdown-hover"><NavLink className={({ isActive }) => (isActive ? 'active' : 'inactive')} to="/callbacks"><FiPhoneCall /> <span className="menu-name">Callbacks</span></NavLink></li>
                    <li className="dropdown-hover"><NavLink className={({ isActive }) => (isActive ? 'active' : 'inactive')} to="/voicemails"><FaVoicemail /> <span className="menu-name">Voicemails</span></NavLink></li>
                    {process.env.REACT_APP_AWS_CCP_FollowupsAvailable === "1" ? (
                        <li className="dropdown-hover"><NavLink className={({ isActive }) => (isActive ? 'active' : 'inactive')} to="/followups"><MdOutlineRepeat /> <span className="menu-name">Follow-ups</span></NavLink></li>
                    ):(
                        <></>
                    )}
                    <li className="dropdown-hover" >  <Link to="#"> <FiFile/> <span className="menu-name" >Important links</span> </Link>
                        <ul className="hover-menu">
                            <li onClick={() => { onDonwloadAgentLogs() }}><Link to="#" className="inactive"><span style={{fontSize: "14px"}}>Agent logs</span></Link></li>
                            <li><a target="_blank" href={`https://tools.connect.aws/endpoint-test/?connectInstanceUrl=${new URL(process.env.REACT_APP_AWS_CCP_URL||"").origin}`}><span style={{fontSize: "14px"}}>Connection test tool</span></a></li>
                            <li><a target="_blank" href={`${process.env.REACT_APP_AWS_CCP_SBS_URL}agent-app-v2/scheduling#/schedule`}><span style={{fontSize: "14px"}}>Schedule tool</span></a></li>
                        </ul>
                    </li>
                </ul>
                <span style={{color: "white", position: "absolute", left: "15%", bottom: "2.5%"}}>v. {process.env.REACT_APP_VERSION}</span>
            </div>
        </React.Fragment>
    );
}

export default Sidebar;
